import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CMSPage from "@/components/CMSPage";
import { AdminDashboard, AdminOrders, AdminProducts, AdminPages, AdminSettings } from "@/components/Admin";
import AdminProductEditPage from "@/components/AdminProductEdit";
import AdminCategories from "@/components/AdminCategories";
import AdminCategoryEditPage from "@/components/AdminCategoryEdit";
import AdminCoupons from "@/components/AdminCoupons";
import AdminCustomers from "@/components/AdminCustomers";

// Pages
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import OrderConfirmationPage from "@/pages/OrderConfirmationPage";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";
import MyAccountPage from "@/pages/MyAccountPage";
import MyOrdersPage from "@/pages/MyOrdersPage";
import OrderCheckPage from "@/pages/OrderCheckPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="flex flex-col min-h-screen bg-slate-50">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/produkty" element={<ProductsPage />} />
                <Route path="/kategorie/:categoryId" element={<CategoryPage />} />
                <Route path="/produkt/:productId" element={<ProductDetailPage />} />
                <Route path="/kosik" element={<CartPage />} />
                <Route path="/pokladna" element={<CheckoutPage />} />
                <Route path="/platba-ok" element={<PaymentSuccessPage />} />
                <Route path="/objednavka/:orderId" element={<OrderConfirmationPage />} />
                <Route path="/prihlaseni" element={<LoginPage />} />
                <Route path="/registrace" element={<RegisterPage />} />
                <Route path="/muj-ucet" element={<MyAccountPage />} />
                <Route path="/objednavky" element={<MyOrdersPage />} />
                <Route path="/sledovani-objednavky" element={<OrderCheckPage />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/objednavky" element={<AdminOrders />} />
                <Route path="/admin/produkty" element={<AdminProducts />} />
                <Route path="/admin/produkty/:productId" element={<AdminProductEditPage />} />
                <Route path="/admin/kategorie" element={<AdminCategories />} />
                <Route path="/admin/kategorie/:categoryId" element={<AdminCategoryEditPage />} />
                <Route path="/admin/stranky" element={<AdminPages />} />
                <Route path="/admin/kupony" element={<AdminCoupons />} />
                <Route path="/admin/zakaznici" element={<AdminCustomers />} />
                <Route path="/admin/nastaveni" element={<AdminSettings />} />
                {/* CMS Pages */}
                <Route path="/o-nas" element={<CMSPage />} />
                <Route path="/dokumenty" element={<CMSPage />} />
                <Route path="/doprava" element={<CMSPage />} />
                <Route path="/kontakty" element={<CMSPage />} />
                <Route path="/obchodni-podminky" element={<CMSPage />} />
                <Route path="/jak-nakupovat" element={<CMSPage />} />
                <Route path="/:slug" element={<CMSPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster position="top-right" richColors />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
